import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { ClientProvider } from "./api/ClientContext";
import { SessionProvider } from "./auth/SessionProvider";
import "./app/theme.css";

const container = document.getElementById("root");
if (!container) throw new Error("The page has no #root element to mount into.");

createRoot(container).render(
  <StrictMode>
    <ClientProvider>
      <SessionProvider>
        <App />
      </SessionProvider>
    </ClientProvider>
  </StrictMode>,
);
